var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "calendar"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M18.375 8.33317H3.375M14.2083 1.6665V4.99984M7.54167 1.6665V4.99984M7.375 18.3332H14.375C15.7751 18.3332 16.4752 18.3332 17.01 18.0607C17.4804 17.821 17.8628 17.4386 18.1025 16.9681C18.375 16.4334 18.375 15.7333 18.375 14.3332V7.33317C18.375 5.93304 18.375 5.23297 18.1025 4.69819C17.8628 4.22779 17.4804 3.84534 17.01 3.60565C16.4752 3.33317 15.7751 3.33317 14.375 3.33317H7.375C5.97487 3.33317 5.2748 3.33317 4.74002 3.60565C4.26962 3.84534 3.88717 4.22779 3.64748 4.69819C3.375 5.23297 3.375 5.93304 3.375 7.33317V14.3332C3.375 15.7333 3.375 16.4334 3.64748 16.9681C3.88717 17.4386 4.26962 17.821 4.74002 18.0607C5.2748 18.3332 5.97487 18.3332 7.375 18.3332Z",
    stroke: "#6C737F",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.e26f038552d2ed48af3f3b6a0d6d4e29.svg";
export { ForwardRef as ReactComponent };